// @ts-nocheck
/* eslint-disable */
export const boldOverspeedIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M12.885 3.142C5.771-2.792-3.435 6.472 2.583 13.548a1.417 1.417 0 0 0 2.422-.283l.375-.673a.61.61 0 0 1 .534-.314h4.17a.61.61 0 0 1 .534.314l.384.692a1.417 1.417 0 0 0 2.384.297 7.37 7.37 0 0 0-.5-10.44m-.382 7.446a.613.613 0 0 1-.805.314L8.723 9.596a1.222 1.222 0 1 1 .49-1.12l2.974 1.306a.61.61 0 0 1 .316.806"/></svg>`,
    name: 'bold-overspeed' as const
};